import React from 'react';
import { isSafari } from '~utils/helpers';
import Block from '~routes/main/userprofile/block';
import Loader from '../team/loader';

function TabTeamLoader() {
    const windowWidth = isSafari() ? document.documentElement.clientWidth : window.innerWidth;
    const isMobile = windowWidth < 1160;
    return (
        <div className="team-tab">
            <Block>
                <Loader isMobile={isMobile}/>
            </Block>
        </div>
    );
}

export default TabTeamLoader;
export { TabTeamLoader };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/tab-team/loader/index.js